import React, { useEffect, useState } from 'react';
import NavBar from '../layout/NavBar';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { fetchStarPolcies , fetchStarHealthPolicyDetails } from '../../services/api/offline-consult';
import { toast } from 'react-toastify';

const StarHealth = () => {
    const [mobileNumber, setmobileNumber] = useState('');
    const [policyType, setPolicyType] = useState('opd');
    const [data, setData] = useState([]);
    const [numberData, setNumberData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [policyNumber, setPolicyNumber] = useState('');
    const [numberLoading, setNumberLoading] = useState(false);

    const fetchData = async () => {
        try {
            setLoading(true);
            if (!mobileNumber || !policyType) {
                toast.error('Please enter both policy number and type');
                return;
            }

            const requestBody = {
                mobileNumber: mobileNumber,
                type: policyType
            };

            const response = await fetchStarPolcies(requestBody);
            if (response) {
                setData(response.data);
            } else {
                setData([]);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            toast.error(error.data?.errorMessage || 'Failed to fetch policies');
            setData([]);
        } finally {
            setLoading(false);
        }
    };

    const fetchStarHealthPolicyDetailsByPolicyNumber = async () => {
        try {
            setNumberLoading(true);
            if (!policyNumber) {
                toast.error('Please enter a policy number');
                return;
            }
    
            const response = await fetchStarHealthPolicyDetails(policyNumber);
            if (response?.data) {
                setNumberData(response.data);
            } else {
                setNumberData([]);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            toast.error(error.data?.errorMessage || 'Failed to fetch policies');
            setNumberData([]);
        } finally {
            setNumberLoading(false);
        }
    };

    const handlemobileNumberChange = (event) => {
        setmobileNumber(event.target.value);
    };

    const handlePolicyTypeChange = (event) => {
        setPolicyType(event.target.value);
    };

    const columns = [
        {
            Header: 'Policy Number',
            accessor: 'policyNumber'
        },
        {
            Header: 'Policy Type',
            accessor: 'productName'
        },
        {
            Header: 'Policy Duration',
            Cell: ({ original }) => (
                <span>
                    {`${new Date(original.policyStartDate).toLocaleDateString()} - ${new Date(original.policyEndDate).toLocaleDateString()}`}
                </span>
            )
        },
        {
            Header: 'Insured Details',
            Cell: ({ original }) => (
                <ReactTable
                    className="-striped -highlight nested-table"
                    data={original.insuredDetails || []}
                    columns={[
                        {
                            Header: 'Name',
                            accessor: 'name'
                        },
                        {
                            Header: 'Health ID',
                            accessor: 'healthId'
                        },
                        {
                            Header: 'Gender',
                            accessor: 'gender'
                        },
                        {
                            Header: 'DOB',
                            accessor: 'dateOfBirth',
                            Cell: ({ value }) => new Date(value).toLocaleDateString()
                        }
                    ]}
                    defaultPageSize={original.insuredDetails?.length || 1}
                    showPagination={false}
                    minRows={1}
                    SubComponent={null}
                />
            )
        }
    ];

    return (
        <div style={{ fontFamily: 'Arial, sans-serif', backgroundColor: '#f9f9f9', minHeight: '100vh', width: '100%' }}>
            <NavBar />
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginTop: '70px',
                    padding: '20px',
                    width: '100%',
                }}
            >
                <h2 style={{ color: '#333', marginBottom: '20px' }}>Fetch Star Policies by Phone Number</h2>
                <div style={{ display: 'flex', width: '100%', gap: '20px', flexDirection: 'column', alignItems: 'center' }}>
                    <div
                        style={{
                            backgroundColor: '#fff',
                            padding: '20px',
                            borderRadius: '8px',
                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                            width: '500px',
                        }}
                    >
                        <div style={{ marginBottom: '15px' }}>
                            <label htmlFor="mobileNumber" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                                Phone Number
                            </label>
                            <input
                                onChange={handlemobileNumberChange}
                                type="number"
                                value={mobileNumber}
                                style={{
                                    width: '100%',
                                    padding: '10px',
                                    borderRadius: '4px',
                                    border: '1px solid #ccc',
                                }}
                            />
                        </div>
                        <div style={{ marginBottom: '15px' }}>
                            <label htmlFor="policyType" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                                Policy Type
                            </label>
                            <select
                                onChange={handlePolicyTypeChange}
                                value={policyType}
                                style={{
                                    width: '100%',
                                    padding: '10px',
                                    borderRadius: '4px',
                                    border: '1px solid #ccc',
                                }}
                            >
                                <option value="opd">OPD</option>
                                <option value="phc">PHC</option>
                            </select>
                        </div>
                        <div>
                            <button
                                type="button"
                                onClick={fetchData}
                                style={{
                                    width: '100%',
                                    padding: '10px',
                                    backgroundColor: '#007bff',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontWeight: 'bold',
                                }}
                            >
                                {loading ? 'Fetching...' : 'Fetch'}
                            </button>
                        </div>
                    </div>
                    <div
                        style={{
                            flex: '2',
                            backgroundColor: '#fff',
                            padding: '20px',
                            borderRadius: '8px',
                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                            overflowX: 'auto',
                            width: '100%',
                        }}
                    >
                        <ReactTable
                            data={data || []}
                            columns={columns}
                            defaultPageSize={5}
                            className="-striped -highlight"
                            noDataText="No policies found"
                            showPagination={true}
                            showPageSizeOptions={true}
                            pageSizeOptions={[5, 10, 20, 25]}
                            minRows={3}
                            resolveData={(data) =>
                                data.map((row) => ({
                                    ...row,
                                    insuredDetails: row.insuredDetails || [],
                                }))
                            }
                            SubComponent={null}
                        />
                    </div>
                </div>
                <div>
                    <h2 style={{ color: '#333', marginTop: '20px', marginBottom: '20px' }}>Fetch Star Health Policy Details By Policy Number</h2>
                    <div style={{ display: 'flex', width: '100%', gap: '20px', flexDirection: 'column', }}>
                        <div
                            style={{
                                backgroundColor: '#fff',
                                padding: '20px',
                                borderRadius: '8px',
                                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                width: '500px',
                            }}
                        >
                            <div style={{ marginBottom: '15px' }}>
                                <label htmlFor="policyNumber" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                                    Policy Number
                                </label>
                                <input
                                    onChange={(e) => setPolicyNumber(e.target.value)}
                                    type="text"
                                    value={policyNumber}
                                    style={{
                                        width: '100%',
                                        padding: '10px',
                                        borderRadius: '4px',
                                        border: '1px solid #ccc',
                                    }}
                                />
                            </div>
                            <div>
                                <button
                                    type="button"
                                    onClick={fetchStarHealthPolicyDetailsByPolicyNumber}
                                    style={{
                                        width: '100%',
                                        padding: '10px',
                                        backgroundColor: '#007bff',
                                        color: '#fff',
                                        border: 'none',
                                        borderRadius: '4px',
                                        cursor: 'pointer',
                                        fontWeight: 'bold',
                                    }}
                                >
                                    {numberLoading ? 'Fetching...' : 'Fetch'}
                                </button>
                            </div>
                        </div>
                        <div
                            style={{
                                flex: '2',
                                backgroundColor: '#fff',
                                padding: '20px',
                                borderRadius: '8px',
                                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                overflowX: 'auto',
                                width: '100%',
                                maxWidth: '1200px'
                            }}
                        > 
                        {numberData.length > 0 && (
                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <tbody>
                                {Object.entries(numberData[0]).map(([key, value]) => (
                                    <tr key={key}>
                                    <td style={{ fontWeight: 'bold', padding: '8px', border: '1px solid #ccc' }}>
                                        {key}
                                    </td>
                                    <td style={{ padding: '8px', border: '1px solid #ccc' }}>
                                        {typeof value === 'string' && value.includes('T')
                                        ? new Date(value).toLocaleString()
                                        : value?.toString()}
                                    </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        )}
                        </div>
                        </div>
                        </div>
            </div>
        </div>
    );
};

export default StarHealth;
